import { COUPON_TYPES } from '../../../../services/exports/Constants';

const Coupons: Record<COUPON_TYPES, string> = {
  [COUPON_TYPES.PROMO_CODE]: 'Código promocional {{code}} aplicado',
  [COUPON_TYPES.CASHBACK]: 'Pontos de fidelidade aplicados',
  [COUPON_TYPES.REWARD]: 'Recompensa aplicada',
  [COUPON_TYPES.GIFT_CARD]: 'Cartão de oferta aplicado',
};

export default Coupons;
